import React from 'react'
import { Typography } from '@mui/material';
import styled from '@emotion/styled';

const StyledPara = styled(Typography)`
font-size: 18px;
font-weight: 500;
    @media(max-width: 600px){
        /* font-size: 14px; */
    }
`
const Paragraph = (props) => {
    const { children, style } = props; 
  return (
    <StyledPara variant="body2" color="#030930"     style={style} 
    {...props} >
    {children}
    </StyledPara>
  )
}

export default Paragraph